/**
 * @desc 导出物料SKU
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.basics.plmProductSku.exportBomSkuExcel.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/product/sku/exportBomSkuExcel`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
